import SidebarMenuItem from "./SidebarMenuItem";
import SidebarMenuItemWithSub from "./SidebarMenuItemWithSub"
const SidebarMenuMain = () => {
    return (
        <>
            <SidebarMenuItem
                to='/agents'
                icon='media/icons/duotune/technology/teh003.svg'
                title="Agents"
                fontIcon='bi-app-indicator'
            />
            <SidebarMenuItemWithSub
                to='/guide'
                title='Guide'
                icon='media/icons/duotune/technology/teh003.svg'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to='/guide/overview' title='Overview' hasBullet={false} />
                <SidebarMenuItem to='/guide/concepts' title='Concepts' hasBullet={false} />
                <SidebarMenuItem to='/guide/channels' title='Channels' hasBullet={false} />
                <SidebarMenuItem to='/guide/deployments' title='Deployments' hasBullet={false} />
                <SidebarMenuItem to='/guide/best-practices' title='Best Practices' hasBullet={false} />
                <SidebarMenuItem to='/guide/tru-chatwidget' title='TruChat Widget' hasBullet={false} />
            </SidebarMenuItemWithSub>
            <SidebarMenuItemWithSub
                to='/report'
                title='Report'
                icon='media/icons/duotune/general/gen005.svg'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to='/report/cdr-report' title='CDR Report' hasBullet={false} />
                <SidebarMenuItem to='/report/missed-chat' title='Missed Chat' hasBullet={false} />
            </SidebarMenuItemWithSub>
        </>
    )
}

export default SidebarMenuMain;